<template>
  <section class="research-item">
    <router-link :to="getResearchLink(item.slug)">
      <img
        v-if="item.slideshow && item.slideshow[0].type === 'image'"
        class="research-item__image"
        :src="item.slideshow[0].image.url"
        :class="{
          'research-item__image--portrait': item.slideshow[0].image.height >= item.slideshow[0].image.width,
          'research-item__image--landscape': item.slideshow[0].image.width > item.slideshow[0].image.height
        }">
      <div class="no-image" v-else></div>
    </router-link>
    <div class="research-item__details">
      <p
        class="research-item__details-name"
        v-html="item.title"></p>
      <p v-html="getDesigners(item.designers)"></p>
      <p v-html="item.year"></p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ResearchItem',
  props: {
    item: Object
  },
  methods: {
    getResearchLink(slug) {
      return `/research/${slug}`
    },
    getDesigners(designers) {
      if (designers) {
        let designersStr = ''
        designers.forEach((designer, index) => {
          designersStr += `${designer.first_name} ${designer.last_name}`
          if (designers.length > 1 && index < designers.length - 1) {
            designersStr += ', '
          }
        })
        return designersStr
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.research-item {
  width: calc(25% - 7.5px);
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  margin:0 10px 20px 0;

  &:nth-child(4n + 4) {
    margin-right:0px;
  }
  &__image, .no-image {
    width:100%;
    height:calc((25vw - 2rem - 20px) * 0.75);
    object-fit:cover;
    object-position: 50% 50%;
    float:left;
    filter: grayscale(100) contrast(1.15);
    transition:filter 180ms ease-in-out;

    &--portrait {
      width:100%;
      object-fit: cover;
      object-position: 50% 50%;
    }
  }
  .no-image {
    background-color:#cecece;
  }
  &__details {
    margin:10px 0 0 0;
    p {
      line-height: $content-line-height;
    }
    &-designer {
      display:flex;
      flex-wrap: wrap;
      p {
        padding-right:0.5rem;
      }
    }
  }

  &:hover {
    img {
      filter:grayscale(0);
    }
    .research-item__details {
      &-name {
        text-decoration: underline;
      }
    }
  }

  @media screen and (max-width: $mobile) {
    width:100%;
    margin:0 0 20px 0;
    img, .no-image {
      height:calc((100vw - 6%) * 0.66);
      object-position: 0% 100%;
      float:left;
    }
    &__details {
      margin:0.5rem 0 0 0;
      height:unset;
      p {
        font-size:$body--m;
      }
    }
  }
}
</style>
